import { BaseCalculatorForm } from '../../types/calculator'
import { calculateMonthlyPersonalPayments } from '../calculatorLogic'
import { PurchasePriceResult } from '../getMaxPurchasePrice'
import { gtmCalculatorDataPush } from '../gtmDataPush'
import { parseFormattedNumber } from '../number'
import { getValue, storeValue } from '../store'

export abstract class CalculatorStore<TForm extends BaseCalculatorForm> {
  abstract id: string
  abstract calculateResult: (formValues: TForm) => PurchasePriceResult

  storeResults = (formValues: TForm) => {
    storeValue(this.id + '-mortgage-calculator/formValues', formValues)

    const result = this.calculateResult(formValues)

    storeValue(this.id + '-mortgage-calculator/results', result)

    gtmCalculatorDataPush(this.id + '-mortgage-calculator', {
      ...result,
      ...formValues,
    })
  }

  getFormValues = () => {
    return getValue<TForm>(this.id + '-mortgage-calculator/formValues')
  }

  getResults = () => {
    return getValue<PurchasePriceResult>(this.id + '-mortgage-calculator/results')
  }

  mapFormValues = (formValues: TForm) => {
    return {
      annualIncome: parseFormattedNumber(formValues.annualIncome),
      monthlyPersonalPayments: calculateMonthlyPersonalPayments(
        parseFormattedNumber(formValues.monthlyPayments),
        parseFormattedNumber(formValues.creditCardDebt),
      ),
      borrowerCreditRating:
        formValues.creditRating === 'good' || formValues.creditRating === 'few-late'
          ? 'good'
          : ('bad' as 'good' | 'bad'),
    }
  }
}
